import React from "react";
import { FaHome, FaFileInvoiceDollar, FaTools, FaNewspaper, FaRobot } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useBuilding } from "../context/BuildingContext";
import styles from "./BottomNav.module.css";

const items = [
  { id: "inicio", label: "Inicio", icon: <FaHome /> },
  { id: "expensas", label: "Gastos Comunes", icon: <FaFileInvoiceDollar /> },
  { id: "problema", label: "Incidencias", icon: <FaTools /> },
  { id: "novedades", label: "Novedades", icon: <FaNewspaper /> },
  { id: "habi", label: "Habi", icon: <FaRobot /> },
];

const BottomNav = ({ selected, setSelected }) => {
  const { t } = useTranslation("nav");
  // Inquilino de una unidad "Alquiler del edificio": lo que paga es alquiler.
  const { soloAlquilerEdificio } = useBuilding() || {};
  const claveDe = (id) => (id === "expensas" && soloAlquilerEdificio ? "alquiler" : id);
  const etiquetaDe = (item) => (claveDe(item.id) === "alquiler" ? "Alquiler" : item.label);
  return (
    <nav className={styles.bottomNav}>
      {items.map((item) => (
        <button
          key={item.id}
          className={`${styles.navItem} ${selected === item.id ? styles.active : ""}`}
          onClick={() => setSelected(item.id)}
        >
          <span className={styles.icon}>{item.icon}</span>
          <span className={styles.label}>{t(`items.${claveDe(item.id)}.label`, etiquetaDe(item))}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
